
import LoginButton from '@/components/LoginButton.vue'

export default {
    name: 'LoginView',
    components: {
        LoginButton,
    },
}
